"use strict";

angular.module('app.shared.userPhoto.userPhotoDirective', [])
    .directive('userPhoto', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/shared/userPhoto/userPhotoView.html',
                scope: {
                    user: '=?'
                }
            }
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/userPhoto/userPhotoDirective.js